import { t } from "i18next";
import Box from "@mui/material/Box";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import { useState } from "react";
import IPhoneSearchPreview from "../components/IPhoneSearchPreview";
import IPhoneSocialPreview from "../components/IPhoneSocialPreview";

import { Grid, Typography, useMediaQuery, useTheme } from "@mui/material";

import "../stylesheets/pages/preview.scss";

export default function Preview() {
  const [previewType, setPreviewType] = useState("social");

  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));

  const handlePreviewChange = (_: unknown, newPreviewType: string) => {
    setPreviewType(newPreviewType);
  };

  return (
    <Box>
      <Grid container spacing={2} justifyContent={"center"}>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" fontWeight={"bold"} color={"secondary"}>
            {t("preview.title")}
          </Typography>
          <Typography marginTop={2} variant="subtitle2" fontWeight={"400"}>
            {t("preview.subTitle")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={5}
          container
          spacing={2}
          columnGap={2}
          justifyContent={"center"}
        >
          {!md && (
            <Grid item xs={12}>
              <ButtonGroup
                className="button-custom-group"
                fullWidth
                sx={{ boxShadow: 0 }}
                color="inherit"
                aria-label="medium button group"
              >
                <Button
                  fullWidth
                  variant="contained"
                  className={
                    previewType === "social"
                      ? "category-button-selected"
                      : "category-button"
                  }
                  disableElevation
                  color={"inherit"}
                  onClick={(event: React.MouseEvent<HTMLElement>) =>
                    handlePreviewChange(event, "social")
                  }
                >
                  {t("preview.socialLabel")}
                </Button>
                <Button
                  variant="contained"
                  fullWidth
                  disableElevation
                  className={
                    previewType === "search"
                      ? "category-button-selected"
                      : "category-button"
                  }
                  color={"inherit"}
                  onClick={(event: React.MouseEvent<HTMLElement>) =>
                    handlePreviewChange(event, "search")
                  }
                >
                  {t("preview.searchLabel")}
                </Button>
              </ButtonGroup>
            </Grid>
          )}
          {md && (
            <>
              <Grid item xs={12} md={5}>
                <Button
                  fullWidth
                  variant="contained"
                  className={
                    previewType === "social"
                      ? "category-button-selected"
                      : "category-button"
                  }
                  disableElevation
                  color={"inherit"}
                  onClick={(event: React.MouseEvent<HTMLElement>) =>
                    handlePreviewChange(event, "social")
                  }
                >
                  {t("preview.socialLabel")}
                </Button>
              </Grid>
              <Grid item xs={12} md={5}>
                <Button
                  variant="contained"
                  fullWidth
                  disableElevation
                  className={
                    previewType === "search"
                      ? "category-button-selected"
                      : "category-button"
                  }
                  color={"inherit"}
                  onClick={(event: React.MouseEvent<HTMLElement>) =>
                    handlePreviewChange(event, "search")
                  }
                >
                  {t("preview.searchLabel")}
                </Button>
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            {previewType === "search" && (
              <Box sx={{ textAlign: "center", paddingTop: "2rem" }}>
                <IPhoneSearchPreview />
              </Box>
            )}
            {previewType === "social" && (
              <Box sx={{ textAlign: "center", paddingTop: "2rem" }}>
                <IPhoneSocialPreview />
              </Box>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
